import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import * as fromRootStore from "../../../reducers";
import {
    ExcelService,

    PurchaseReportService
} from "../../../services/index";
import * as fromCommonStore from "../../../store";

@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./lorryReport.html",
})
export class LRInvoiceReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];
  exceldata: any;
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  partyList$ = [];
  partyList: Observable<any[]>;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "lr_no",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;

  columns = [];
  toggleCol = [];
  typelist = ["COURIER", "TRANSPORT", "HAND DELIVERY"];
  filterExpand = false;
  statusList = ["YES", "NO"];
  stageList = ["LR Open", "LR Delivery", "LR Closed"];
  filterData: any = {
    lr_no: "",
    recd_no: "",
    status: "",
    stage: "",
    type: "TRANSPORT",
  };

  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;

  printConfig: any = {
    title: "Lorry Details Report",
    columns: [],
    rows: [],
  };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purService: PurchaseReportService,
    public toasterService: ToasterService
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    this.invoiceStoreSub = this.store
      .select(fromRootStore.getLoadInvoice)
      .subscribe((isLoad: any) => {
        if (isLoad) {
          this.getInvoiceList();
        }
      });

    this.partyStoreSub = this.store
      .select(fromCommonStore.getAllParty)
      .subscribe((res: any) => {
        if (_.isEmpty(res)) {
          return;
        }
        this.partyList$ = res.data;
      });

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        sortable: false,
        cellClass: "text-center",
        cellTemplate: this.snoTemplate,
        toggle: true,
        isPrint: true,
      },
      {
        name: "LR No",
        prop: "lr_no",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
        align: "right",
        type: "number",
        cellClass: "text-left",
      },
      {
        name: "LR Date",
        prop: "lr_date",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        headerClass: "text-center",
        align: "right",
        type: "number",
        cellClass: "text-center",
      },
      {
        name: "Invoice Name",
        prop: "party_name",
        minWidth: 110,
        maxWidth: 110,
        width: 110,
        headerClass: "text-center",
        align: "left",
        type: "text",
        cellClass: "text-center",
      },
      {
        name: "LR Amount",
        prop: "lr_amount",
        minWidth: 90,
        maxWidth: 136,
        width: 136,
        headerClass: "text-center",
        align: "right",
        type: "number",
        cellClass: "text-right",
      },
      {
        name: "PVT Mark",
        prop: "pvt_mark",
        minWidth: 136,
        maxWidth: 90,
        width: 90,
        headerClass: "text-center",
        align: "right",
        type: "text",
        cellClass: "text-right",
      },
      {
        name: "Charge Weight",
        prop: "chr_wt",
        minWidth: 90,
        maxWidth: 90,
        width: 70,
        headerClass: "text-center",
        align: "right",
        type: "number",
        cellClass: "text-right",
      },
      {
        name: "Actual Weight",
        prop: "act_wt",
        minWidth: 90,
        maxWidth: 90,
        width: 70,
        headerClass: "text-center",
        align: "right",
        type: "number",
        cellClass: "text-right",
      },
      {
        name: "Received Weight",
        prop: "rec_wt",
        minWidth: 90,
        maxWidth: 90,
        width: 70,
        headerClass: "text-center",
        align: "right",
        type: "number",
        cellClass: "text-right",
      },
      {
        name: "No Of Bales",
        prop: "no_of_bundle",
        minWidth: 90,
        maxWidth: 90,
        width: 70,
        headerClass: "text-center",
        align: "right",
        type: "number",
        cellClass: "text-right",
      },
      {
        name: "TDS",
        prop: "tds_amount",
        minWidth: 90,
        maxWidth: 90,
        width: 70,
        headerClass: "text-center",
        align: "right",
        type: "number",
        cellClass: "text-right",
      },
      {
        name: "Receipt No",
        prop: "rec_no",
        cellClass: "text-center",
        headerClass: "text-center",
        maxWidth: 120,
        width: 120,
        sortable: false,
      },
      {
        name: "Received Date",
        prop: "rec_date",
        minWidth: 120,
        headerClass: "text-center",
        maxWidth: 120,
        width: 120,
        sortable: false,
        cellClass: "text-center",
      },
    ];
    if (this.filterData.type == "TRANSPORT") {
      this.columns.push({
        name: "LR status",
        prop: "lr_stage",
        minWidth: 80,
        headerClass: "text-center",
        maxWidth: 120,
        width: 120,
        sortable: false,
        cellClass: "text-center",
      });
    }
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterinvno").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getInvoiceList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "applyFilter") {
      this.applyFilter();
    } else {
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getInvoiceList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getInvoiceList();
  }

  getInvoiceList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      lr_no: this.filterData.lr_no,
      recd_no: this.filterData.recd_no,
      status: this.filterData.status,
      stage: this.filterData.stage,
      type: this.filterData.type,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.purService
      .getLRDetails(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.invoiceData = res.data;

        that.gridOptions = {
          columns: that.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Lorry Details Report",
          columns: that.columns,
          rows: that.invoiceData,
        };
        that.exceldata = that.getData(that.columns, res.data);
      });
  }

  clearFilter(): void {
    this.filterData.lr_no = "";
    this.filterData.recd_no = "";
    this.filterData.status = "";
    this.filterData.stage = "";
    this.filterData.type = "TRANSPORT";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.ngOnInit();
    this.getInvoiceList();
  }

  /*  filterItems(name: string, comboType: string) {
          let list: any[];
          if (comboType == "Party") {
              list = this.partyList$
          }
          name = _.escapeRegExp(name);
          return list.filter(item => (new RegExp(name, 'gi').test(item.name)));
      }*/

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  @ViewChild("printPage") printPage;
  onPrintInvoice(row) {
    this.printConfig = {
      type: "invoice",
      title: "Sales Invoice",
      rows: row,
    };

    setTimeout(() => {
      this.printPage.printPreview();
    }, 100);
  }

  ngOnDestroy() {
    this.partyStoreSub.unsubscribe();
    this.invoiceStoreSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/lorryReport/lorryReport.ts